import { FC, } from 'react';
import { Space } from 'antd';
import { SpaceProps } from 'antd/lib/space';

const ProSpace: FC<SpaceProps> = (props) => {
  const { children, ...resProps } = props;
  return <Space {...resProps}>{children}</Space>;
};

export default ProSpace;
